import { Customer } from '../types';

type HasCurrentMeasureInsurance = (
  Customer: Partial<Customer> | null,
) => boolean;

export const hasCurrentMeasureInsurance: HasCurrentMeasureInsurance = customer => {
  const dateInPast = function (firstDate: Date, secondDate: Date) {
    if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
      return true;
    }

    return false;
  };
  const measureInsurance =
    customer !== null && customer.tags
      ? customer.tags.find(tag => tag.includes('MeasureInsurance:'))
      : false;

  let newDate;
  let measureInsuranceHasPassed;
  if (measureInsurance !== false && typeof measureInsurance === 'string') {
    const dateString = measureInsurance.replace('MeasureInsurance:', '');
    const measureInsuranceDate = new Date(dateString);
    newDate = new Date(
      measureInsuranceDate.setDate(measureInsuranceDate.getDate() + 182),
    );

    const today = new Date();
    measureInsuranceHasPassed = dateInPast(newDate, today);
  }

  return measureInsurance === false || measureInsuranceHasPassed === true
    ? false
    : true;
};
